import { IClient, IClientInfo, IUploadReportMap } from 'src/integration/api/client/client.model';
import { ClientConfig, IClientConfigObj } from 'src/integration/api/client/ClientConfig';
import { IJsFileReferences } from 'src/integration/api/client/FileReference';
import { generateAxeFeedback } from 'src/shared/feedback/axefeedback';
import { FileType } from 'src/shared/file-type.model';
import { LmsType } from 'src/shared/lms-type.model';

export class AnonymousClient implements IClient {

    public config: ClientConfig;
    public jQuery: JQueryStatic;

    constructor(config: IClientConfigObj, private readonly lmsType: LmsType) {
        this.config = ClientConfig.fromConfigObject(config);
        this.jQuery = this.config.jQuery;
    }

    public generateAxeFeedback(axeResults: JSON): Promise<any> {
        return Promise.resolve(
            generateAxeFeedback(this.lmsType, FileType.HtmlFragment, axeResults as any)
        );
    }

    public getClientInfo(_courseId: string | null): Promise<IClientInfo> {
        return Promise.resolve({
            'flags': {
                'ifLaunchFromWysiwyg': true,
                'nativeWysiwygAxEnabled': false
            }
        });
    }

    public applyWysiwygFix(_courseId: string, _fileId: string, _quickFix: any): Promise<string> {
        return Promise.reject('Not supported.');
    }

    public authenticate(_: JQuery.UrlAjaxSettings): Promise<JQuery.UrlAjaxSettings> {
        return Promise.reject('Not supported.');
    }

    public authenticateAndExec(_: JQuery.UrlAjaxSettings): Promise<any> {
        return Promise.reject('Not supported.');
    }

    public getFileReports(_courseId: string, _refsById: IJsFileReferences): Promise<IUploadReportMap> {
        return Promise.reject('Not supported.');
    }

    /* istanbul ignore next */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public clearAllFromCache(): void {
    }

    /* istanbul ignore next */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public clearFileIdFromCache(_fileId: string): void {
    }
}
